<template>
  <div>
    <div id="Tmall">
      <div class="Tmall_left">
        <div class="left_top">
          <div class="sale">
            <p>当日销售额</p>
            <span>(RMB`000)</span>
          </div>
          <b>{{ oldSalesValue | NumFormat }}</b>
        </div>
        <div class="left_top">
          <div class="sale">
            <p>累计达成销售额</p>
            <span>(RMB`000)</span>
          </div>
          <b>{{ salesValue | NumFormat }}</b>
        </div>
        <!-- <div class="left_top">
          <div class="sale">
            <p>全网阶段目标</p>
             <p>第一波完成率</p>
          </div>
           <div class="dachen">
          <b>{{ targetValue | NumFormat }}</b>
            <span>{{Proportion}}%</span>
          </div>
        </div> -->
        <div class="left_top">
          <div class="sale">
            <p>Tmall Fs总目标</p>
            <!-- <p>全网总目标</p> -->
           <p>总完成率</p>
          </div>
          <div class="dachen">
          <b>{{ allTargetValue | NumFormat }}</b>
            <span>{{allProportion}}%</span>
          </div>
        </div>
      </div>
      <div class="middle"></div>
      <div class="Tmall_right">
        <p>总完成率</p>
        <!-- <p>第一波完成率</p> -->
        <Circular :Proportion="allProportion" :bindEl="bindEl"></Circular>
      </div>
    </div>
  </div>
</template>
<script>
import Circular from "@/components/public/circular";
import { Toast } from "vant";

export default {
  data() {
    return {
      Proportion: 0,
      allProportion:0,
      salesValue: 0,
      targetValue: 0,
      allTargetValue:0,
      oldSalesValue: 0,
      bindEl: "PosTmall",
      time: "",
    };
  },
  components: {
    Circular,
  },
  methods: {
    getSum() {
      // Toast.loading({
      //   message: "加载中...",
      //   forbidClick: true
      // });
      var day1 = new Date();
      day1.setTime(day1.getTime() - 24 * 60 * 60 * 1000);
      var s1 =
        day1.getFullYear() +
        "" +
        (day1.getMonth() + 1).toString().padStart(2, 0) +
        day1.getDate().toString().padStart(2, 0);
      this.$addr
        .post(`Sales/getTmallSumData?type=1&monthDate=${s1}`)
        .then((res) => {
          this.Proportion = Math.round(parseFloat(res.data.data[0].today_achieving))||'0';
          this.allProportion = Math.round(parseFloat(res.data.data[0].achieving));
          this.salesValue = res.data.data[0].salesValue;
          this.targetValue = res.data.data[0].today_target;
          this.allTargetValue = res.data.data[0].targetValue;
          res.data.dataOld[0] == null
            ? (this.oldSalesValue = 0)
            : (this.oldSalesValue = res.data.dataOld[0].salesValue);
          Toast.clear();
        });
    },
  },
  created() {
    this.getSum();
  },
  props: ["upTime"],
  watch: {
    upTime: {
      handler(newVal, oldVal) {
        this.time = newVal.replace("-", "月");
      },
    },
  },
};
</script>
<style scoped>
#Tmall {
  overflow: hidden;
  clear: both;
  display: flex;
  box-sizing: border-box;
  text-align: center;
  height: 260px;
}
.Tmall_left {
  width: 225px;
  height: 100%;
  margin: 34px 19px 32px 34px;
}
.Tmall_left .left_top {
  display: flex;
  font-family: "PingFangSC-Medium";
  font-size: 13px;
  justify-content: space-between;
}
.Tmall_left .left_top p {
  line-height: 0.382979rem;
  color: #191919;
  flex: 1;
  min-width: 80px;
}
.Tmall_left .left_top span {
   font-size: 11px;
  line-height: 18px;
  color: rgba(13, 13, 13, 0.3);
}
.sale {
  min-width: 90px;
  text-align: right;
  margin: 0 12px 20px 0;
}
.dachen{
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: start;
}
.dachen span{
  font-weight: bold;
  font-size: 14px !important;
  text-align: right;
  color: #191919 !important;
  width: 100%;
  line-height: 10px !important;
}
.Tmall_left .left_top b {
  opacity: 0.91;
  font-family: "Arial-BoldMT";
  font-size: 20px;
  color: #282828;
  text-align: center;
}
.middle {
  margin: 20px 0;
  width: 1px;
  height: 195px;
  border: 1px solid rgba(157, 157, 157, 0.4);
}
.Tmall_right {
  padding: 25px 0;
  margin: 0px 31px 22px 19px;
  width: 187px;
  height: 100%;
  text-align: center;
  z-index: 3;
  position: relative;
}
.Tmall_right p {
  font-family: "PingFangSC-Medium";
  font-size: 13px;
  color: #191919;
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/Pos/pos_Tmall.vue